import { render, staticRenderFns } from "./SampleSetTestsTable.vue?vue&type=template&id=77f4c719"
import script from "./SampleSetTestsTable.vue?vue&type=script&lang=js"
export * from "./SampleSetTestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports